import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/product-types`,
  requesterType: 'CMS_WEB_SERVICE',
};
const productTypesApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const productTypesApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return productTypesApiReqErrorHandling;
  }

  return productTypesApiReqNotification;
};

class ProductTypeApi {
  fetchProductTypes(errorManagementType) {
    return getRequester(errorManagementType)
      .get('/', {
        headers: {
          'accept-language': i18n.locale,
        },
      }).then(res => res && res.data);
  }
}

export default new ProductTypeApi();
